export const messageValidator = {
    email_required: "* Email không được bỏ trống",
    email_invalid: "* Email sai định dạng, bạn kiểm tra lại nhé",
    password_required: "* Mật khẩu không được bỏ trống",
    password_min: "* Mật khẩu cần có ít nhất 06 ký tự",
    user_name_required: "* Tên hiển thị không được bỏ trống",
    user_name_size: "* Tên hiển thị cần có từ 3-15 ký tự"
}